export const SET_NEWS_FETCHING = 'SET_NEWS_FETCHING';
export const SET_NEWS = 'SET_NEWS';
export const SET_NEWS_ERROR = 'SET_NEWS_ERROR';
export const CLEAN_NEWS = 'CLEAN_NEWS';
export const UPDATE_NEWS_FEED_AFTER_READ_USERACTION = 'UPDATE_NEWS_FEED_AFTER_READ_USERACTION';
export const UPDATE_NEWS_FEED_AFTER_RATE_USERACTION = 'UPDATE_NEWS_FEED_AFTER_RATE_USERACTION';
export const UPDATE_NEWS_FEED_AFTER_CHANGE_IMPORTANCE = 'UPDATE_NEWS_FEED_AFTER_CHANGE_IMPORTANCE';
export const ABORT_NEWS_REQUEST = 'ABORT_NEWS_REQUEST';
export const RESET_NEWS_FETCHING = 'RESET_NEWS_FETCHING';



// WEBPACK FOOTER //
// ./src/redux_related/allNews/actions.js